<template>
  <el-form
    :model="form"
    label-width="100px"
    :label-position="labelPosition"
    :rules="rules"
  >
    <el-row :gutter="25">
      <el-col :span="24">
        <el-form-item label="Nome:" prop="firstName">
          <el-input v-model="form.firstName" placeholder="Nome" />
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="Sobrenome:" prop="lastName">
          <el-input v-model="form.lastName" placeholder="Sobrenome" />
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="Email:" prop="email">
          <el-input v-model="form.email" placeholder="Email" type="email" />
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="Telefone:" prop="phone">
          <el-input
            v-model="form.phone"
            v-mask="'(##) #####-####'"
            maxlength="15"
            placeholder="(XX) XXXXX-XXXX"
            masked="true"
          />
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="Endereço:" prop="location">
          <el-input
            v-model="form.location"
            placeholder="Rua, Jacaraú, Engenho do Meio"
          />
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="Sobre Você:" prop="about">
          <el-input v-model="form.about" placeholder="Sobre Você" />
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="Senha:" prop="password">
          <el-input
            v-model="form.password"
            placeholder="Sobre Você"
            type="password"
            show-password
          />
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="Confirmar:" prop="confirmPassword">
          <el-input
            v-model="form.confirmPassword"
            placeholder="Sobre Você"
            type="password"
            show-password
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Cartão:" prop="cartao">
          <el-input
            v-model="form.cartao"
            v-mask="'####-####-####-####'"
            placeholder="Numero do Cartão"
            type="text"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="CCV:" prop="ccv">
          <el-input
            v-model="form.ccv"
            placeholder="CCV: 523"
            type="number"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="CPF:" prop="cpf">
          <el-input
            v-model="form.cpf"
            placeholder="CPF"
            v-mask="'###.###.###-##'"
            type="text"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Titular:" prop="titula">
          <el-input
            v-model="form.titular"
            placeholder="Nome do Titular"
            type="text"
          />
        </el-form-item>
      </el-col>

      <el-button type="primary" @click="createUser(form)"
        >Torna-se Aluno</el-button
      >
    </el-row>
  </el-form>
</template>


<script lang="ts">
// import AuthService from '../../service/AuthService/AuthService';
import { mask } from 'vue-the-mask';
// const app = new AuthService();
export default {
  directives: { mask },
  data() {
    const validateEmail = (rule, value, callback) => {
      if (value.includes('@') && value.includes('.com')) {
        callback();
      }
      callback(new Error('Email Invalido'));
    };

    const validatePassword = (rule, value, callback) => {
      if (value === this.form.password) {
        callback();
      }
      callback(new Error('As senhas precisam ser Iguais'));
    };
    return {
      labelPosition: 'top',
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        location: '',
        about: '',
        password: '',
        confirmPassword: '',
        cartao: '',
        cpf: '',
        ccv: '',
        titular: '',
      },
      rules: {
        firstName: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
        ],
        lastName: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
        ],
        email: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' },
        ],
        phone: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
          { min: 8, max: 15, message: 'Telefone Incompleto' },
        ],
        location: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
        ],
        about: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
        ],
        password: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    async createUser(form) {
      console.log(form);
      // this.$router.push('/course/16/17/Curso-Javascript')
      this.$router.push('/overview/learning')
      // this.form.phone = this.form.phone.replace(/[^0-9]/g, '');

      // await app.register(form).then(
      //   (response) => {
      //     if (response.status === 201) {
      //       this.$router.push('/entrar/status');
      //     }
      //   },
      //   (error) => {
      //     const menssagem = error.response.data;
      //     this.ErroNotification(menssagem.message);
      //     // console.log(menssagem.message);
      //   }
      // );
    },

    ErroNotification(menssagem) {
      this.$notify.error({
        title: 'Error',
        message: menssagem,
        position: 'bottom-right',
      });
    },
  },
};
</script>

<style>
.el-form-item__label {
  font-size: 15px;
  padding: auto;
}
.el-form-item {
  margin-bottom: 10px;
}
.el-button {
  margin-top: 15px;
  margin-left: 15px;
}
</style>